(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[50660],{

/***/ 50660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ MakeItEasy; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/styles/variables/contentintelligenceVariables.module.scss
var contentintelligenceVariables_module = __webpack_require__(21076);
var contentintelligenceVariables_module_default = /*#__PURE__*/__webpack_require__.n(contentintelligenceVariables_module);
// EXTERNAL MODULE: ./src/components/contentintelligence/makeItEasy/styles.module.scss
var styles_module = __webpack_require__(30707);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/contentintelligence/svgs/pointing.tsx


function Pointing() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "31",
        height: "40",
        fill: "none",
        viewBox: "0 0 31 40",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "#442293",
            d: "M27.757 22.196a.606.606 0 00.043-.102 3.76 3.76 0 00-.648-4.444 3.851 3.851 0 00-1.158-.816 3.757 3.757 0 00-.615-4.494 4.4 4.4 0 00-1.577-1.002l5.521-5.24.012-.011a4.197 4.197 0 001.255-2.348 3.188 3.188 0 00-.891-2.756A3.136 3.136 0 0027.419 0a3.99 3.99 0 00-2.74 1.204l-14.451 12.92a3.832 3.832 0 01-.365.296c.277-2.191.13-9.666-3.28-10.966-1.625-.62-3.26-.204-4.252 1.25-.79 1.16-1.227 2.905-1.334 5.336l-.97 16.735a9.964 9.964 0 00.692 4.448c.472 1.092 2.42 4.892 7.646 7.951 1.562.915 3.962 1.17 5.58.25 4.816-2.733 14.678-10.68 15.095-11.018.031-.025.061-.051.09-.08a3.71 3.71 0 00-.039-5.238 3.89 3.89 0 00-1.334-.893z"
        })
    });
}
/* harmony default export */ var pointing = (Pointing);

;// CONCATENATED MODULE: ./src/components/contentintelligence/svgs/squares.tsx


function Squares() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40",
        height: "40",
        fill: "none",
        viewBox: "0 0 40 40",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "#442293",
            d: "M18.704 26.593v8.11A5.297 5.297 0 0113.407 40h-8.11A5.307 5.307 0 010 34.703v-8.11a5.298 5.298 0 015.297-5.297h8.11a5.297 5.297 0 015.297 5.297zM13.407 0h-8.11A5.307 5.307 0 000 5.297v8.12a5.307 5.307 0 005.297 5.297h8.11a5.296 5.296 0 005.297-5.297v-8.12A5.297 5.297 0 0013.407 0zm21.286 21.295h-8.11a5.298 5.298 0 00-5.297 5.297v8.11A5.307 5.307 0 0026.583 40h8.11a5.296 5.296 0 005.297-5.297v-8.11a5.298 5.298 0 00-5.297-5.297zM22.615 6.568l1.349-2.465c.549-.135 1.79-.26 2.167.135l2.032-1.243c-.183-.51.51-1.56.876-1.983l2.813-.068c.394.414 1.126 1.425.963 1.946l2.1 1.146c.346-.414 1.598-.346 2.157-.231l1.464 2.398c-.164.54-.674 1.686-1.204 1.81l.048 2.38c.54.096 1.108 1.213 1.291 1.753l-1.348 2.465c-.559.135-1.801.26-2.167-.135l-2.042 1.243c.183.51-.501 1.56-.877 1.984l-2.802.067c-.395-.414-1.127-1.425-.973-1.945l-2.09-1.147c-.356.414-1.599.347-2.167.241l-1.454-2.398c.164-.55.674-1.695 1.204-1.82l-.058-2.38c-.53-.096-1.099-1.213-1.282-1.753zm6.83 4.98h-.001a2.5 2.5 0 003.586-2.903 2.496 2.496 0 00-4.588-.487 2.494 2.494 0 001.002 3.39z"
        })
    });
}
/* harmony default export */ var squares = (Squares);

;// CONCATENATED MODULE: ./src/components/contentintelligence/svgs/arrowUp.tsx


function ArrowUp() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "30",
        height: "40",
        fill: "none",
        viewBox: "0 0 30 40",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "#442293",
            fillRule: "evenodd",
            d: "M17.467 10.055V22.96c0 1.986-.788 3.89-2.192 5.294L4.26 39.269A2.495 2.495 0 11.73 35.74l11.015-11.015a2.496 2.496 0 00.731-1.765V10.056h-6.55a.749.749 0 01-.521-1.287L14.105.35a1.247 1.247 0 011.735 0l8.7 8.418a.749.749 0 01-.521 1.287h-6.552zm.731 21.727a2.495 2.495 0 113.53-3.529l7.485 7.486a2.495 2.495 0 11-3.529 3.529l-7.486-7.486z",
            clipRule: "evenodd"
        })
    });
}
/* harmony default export */ var arrowUp = (ArrowUp);

;// CONCATENATED MODULE: ./src/components/contentintelligence/svgs/gear.tsx


function Gear() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "41",
        height: "40",
        fill: "none",
        viewBox: "0 0 41 40",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "#442293",
            d: "M34.31 26.859a1.735 1.735 0 00.177 1.657c.364.545.675 1.123.928 1.728a2.92 2.92 0 01-.623 3.244L33.5 34.781a2.898 2.898 0 01-3.245.623 10.146 10.146 0 01-1.727-.929 1.739 1.739 0 00-1.658-.176l-1.598.67a1.708 1.708 0 00-1.046 1.281 11.03 11.03 0 01-.577 1.893A2.91 2.91 0 0120.922 40H19.09a2.91 2.91 0 01-2.727-1.857 11.03 11.03 0 01-.576-1.893 1.709 1.709 0 00-1.046-1.28l-1.599-.67a1.739 1.739 0 00-1.657.175c-.545.365-1.123.676-1.728.929a2.9 2.9 0 01-3.244-.623l-1.293-1.293a2.922 2.922 0 01-.623-3.244c.253-.605.564-1.183.929-1.728.337-.486.404-1.111.176-1.657l-.658-1.599a1.746 1.746 0 00-1.293-1.046 11.025 11.025 0 01-1.893-.576A2.904 2.904 0 010 20.91v-1.834a2.91 2.91 0 011.857-2.727c.611-.249 1.245-.438 1.893-.564a1.762 1.762 0 001.293-1.058L5.7 13.13a1.714 1.714 0 00-.176-1.646 10.692 10.692 0 01-.929-1.74A2.925 2.925 0 015.219 6.5l1.293-1.292a2.92 2.92 0 013.244-.624c.605.258 1.183.573 1.728.94.49.33 1.112.391 1.657.165l1.599-.658a1.746 1.746 0 001.046-1.293c.135-.647.328-1.28.576-1.892A2.894 2.894 0 0119.09 0h1.834a2.898 2.898 0 012.727 1.846c.248.612.44 1.245.576 1.892.108.58.501 1.066 1.046 1.293l1.599.658a1.764 1.764 0 001.657-.164 10.312 10.312 0 011.728-.94 2.923 2.923 0 013.244.622L34.793 6.5a2.928 2.928 0 01.623 3.245c-.256.607-.566 1.19-.929 1.74a1.713 1.713 0 00-.176 1.645l.658 1.599c.226.547.712.944 1.293 1.057.648.126 1.281.315 1.893.565a2.907 2.907 0 011.856 2.726v1.834a2.904 2.904 0 01-1.856 2.727c-.613.248-1.246.441-1.893.576a1.746 1.746 0 00-1.293 1.046l-.659 1.599zm-5.465-6.865a8.84 8.84 0 10-8.84 8.84 8.848 8.848 0 008.84-8.839z"
        })
    });
}
/* harmony default export */ var gear = (Gear);

;// CONCATENATED MODULE: ./src/components/contentintelligence/makeItEasy/index.tsx








function MakeItEasy() {
    const list = [
        {
            title: "Work Smarter with Optimized Processes",
            points: [
                "Accelerate Transformation with a No-Code Process Designer",
                "Digitize and Automate Form Submissions",
                "Gain Actionable Business Intelligence", 
            ],
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(gear, {})
        },
        {
            title: "Manage All Stages of Your Content",
            points: [
                "Centralize Your Enterprise Content",
                "Connect and Collaborate with Teammates and Customers",
                "Manage the Full Records Lifecycle", 
            ],
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(squares, {})
        },
        {
            title: "Make Content Easily Accessible and Searchable",
            points: [
                "Accurately Capture Invoice Information with A.I.",
                "Streamline High-Volume Capture",
                "Quickly Find Content", 
            ],
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(pointing, {})
        },
        {
            title: "Unify the Systems Your Teams Use Every Day",
            points: [
                "Automatically Sync Your Data with Direct Integrations",
                "Create Custom Integrations that Fit Your Business",
                "Integrate Legacy Systems with RPA", 
            ],
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrowUp, {})
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "flex flex-col mt-10 lg:mt-16 mb-10",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-center capitalize text-xl lg:text-4xl mb-14",
                children: "we make it easy for you"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-1 gap-8 lg:grid-cols-2",
                children: list.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-start gap-8 p-8 md:p-16 rounded-sm",
                        style: {
                            boxShadow: "0px 0px 17px 1px rgba(0, 0, 0, 0.1)"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: item.icon
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        style: {
                                            color: (contentintelligenceVariables_module_default()).purple
                                        },
                                        className: "text-lg md:text-2xl",
                                        children: item.title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: (styles_module_default()).list,
                                children: item.points.map((point, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        style: {
                                            color: "#565656"
                                        },
                                        className: "flex gap-3 font-light",
                                        children: [
                                            "•",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "",
                                                children: point
                                            }, index)
                                        ]
                                    }, index))
                            })
                        ]
                    }, index))
            })
        ]
    });
}


/***/ }),

/***/ 30707:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);